import React from 'react';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';

function TabPanel({ children, value, index, className = '', ...other }) {
  const { semantic } = useColors();
  
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      className={className}
      {...other}
    >
      {value === index && (
        <div className={`p-3 ${semantic.contentCardBg}`}>
          {children}
        </div>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  className: PropTypes.string
};

export default TabPanel;

